<template>
  <div class="root d-inline-block">
    <!--<div class="input-group">
      <div v-if="mode==='view'">
        <div v-if="user.haveCompanyPost">
          <button class="btn btn-secondary" @click="openModal('view')">
            <i class="icon-eye-outline"></i>
          </button>
        </div>
        <div v-if="!user.haveCompanyPost">ندارد</div>
      </div>

      <button v-if="mode==='create'" class="btn btn-success" @click="openModal('create')">
        <i class="icon-content-duplicate"></i>
      </button>
      <button v-if="mode==='edit' && user.id" class="btn btn-secendory" @click="openModal('edit')">
        <i class="icon-bd-pencil"></i>
      </button>
    </div>-->
    <b-modal ref="problemsModal" id="modal-center" class="accounting-modal" centered size="lg" title="مشکلات"
             :ok-title="'ذخیره'" :cancel-title="'لغو'" @ok="onProblemModalOk">
      <vs-table v-if="show" ref="userRoleTable" :params="tableParams" :options="tableOptions"></vs-table>
    </b-modal>
  </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from "vuex";
    import BaseService from "../_framework/api/BaseService.js";
    import Utils from "../_framework/utils/Utils.js";
    import VsSelect from "../_framework/VsSelect";
    import VsTableMixin from "../_framework/VsTableMixin.js";
    import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
    import Products from "../pages/Products.vue";
    import EventBus from "../bus.js";

    export default {
        name: "show-problems-modal",
        props: {
            headerKey: null,
            row: null,
            mode: {
                default: "view",
                type: String
            },
            params: {},
            entity: ""
        },
        mixins: [VsTableMixin],
        components: {
            VsSelect,
        },
        data() {
            return {
                userId: 0,
                show: true,
                user: {},
                servicesList: [],
                selectedValue: '',
                posts: [
                    {
                        userId: 0,
                        postId: 0,
                        companyId: null,
                        outSourceId: null
                    }
                ],
                tableParams: {
                    list: [],
                    // entity: "CompanyUserPost",
                    headers: {
                        company: {
                            title: "شرکت داخلی",
                            type: "custom",
                            component: "vs-select",
                            multiple: false,
                            label: "companyName",
                            inHeader: true,
                            listParams: {
                                requestURI: 'company/getAll'
                            },
                            rowAlignment: "center"
                        },
                    }
                },
                tableOptions: {
                    dataSourceType: "store",
                    hasActionsInHeader: true,
                    clickableRows: true,
                    beforeCreateEntity: input => {

                    },
                    beforeUpdateEntity: input => {

                    },
                    beforeFetchEntityList: input => {

                    },
                    hasActions: false,
                    onRowClicked: row => {
                    },

                }
            };
        },
        mounted() {

        },
        beforeMount() {

        },
        methods: {
            refreshTable() {
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
                // this.$refs.table.onFetchEntityList();
            },
            btnClicked() {
                this.$refs.problemsModal.show();
            },
            onProblemModalOk() {
                this.$emit(
                    "dataChanged",
                    this.headerKey,
                    this.vsTableFeed.map(m => {
                        return m;
                    })
                );
            },
            insertRow(data) {
                if (data !== null) {
                    this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
                        id: Math.round(Math.random() * 1000),
                        company: data.company,
                        outSource: data.outSource,
                        post: data.post
                    });
                }
            },
            deleteuserRoleTableRow(id) {
                this.$store.commit(
                    "RESET_VS_TABLE_FEED",
                    this.vsTableFeed.filter(ur => {
                        return ur.id !== id;
                    })
                );
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
            },
            refreshUserRoleTable() {
                if (this.$refs.userRoleTable) {
                    this.$refs.userRoleTable.onFetchEntityList();
                }
                this.show = false;
                setTimeout(() => {
                    this.show = true;
                }, 50);
            }
        },
        computed: {
            ...mapState(["selectedRows", "currentService", "vsTableFeed"]),
        }
    };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
